import Vue from 'vue'

Vue.component('TheDropDownButton',
    () => import('../components/buttons/DropDownButton')
)